import { APP_PERMISSIONS } from '@exam-management/permissions';
import { CreateQConfigButton, QConfigList } from '@exam-management/qconfig-list';
import { Flex, PaperSection } from '@shared/components';
import { WithPermission } from '@shared/permissions';

export default function QConfigListPage() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        width: '100%',
        p: theme.spacing(6),
        minHeight: 'fit-content',
        height: '100dvh',
      })}
    >
      <Flex sx={{ flexGrow: 1 }}>
        <PaperSection
          title='QConfig'
          endAdornment={
            <WithPermission requiredPermission={APP_PERMISSIONS.EXAM.QCONFIG.CREATE}>
              <CreateQConfigButton />
            </WithPermission>
          }
        >
          <Flex
            sx={(theme) => ({
              flexDirection: 'column',
              height: '100%',
              gap: theme.spacing(6),
              p: theme.spacing(6),
            })}
          >
            <QConfigList />
          </Flex>
        </PaperSection>
      </Flex>
    </Flex>
  );
}
